export default __webpack_public_path__ + "static/media/arrow-left-quick-game.a722e5da.svg";